import { render, staticRenderFns } from "./user-edit-form.html?vue&type=template&id=5a32fa21&scoped=true&"
import script from "./user-edit-form.ts?vue&type=script&lang=js&"
export * from "./user-edit-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32fa21",
  null
  
)

export default component.exports